import { render, staticRenderFns } from "./EmailThankMessageDelivery.vue?vue&type=template&id=490445d1&scoped=true&lang=pug&"
import script from "./EmailThankMessageDelivery.vue?vue&type=script&lang=js&"
export * from "./EmailThankMessageDelivery.vue?vue&type=script&lang=js&"
import style0 from "./EmailThankMessageDelivery.vue?vue&type=style&index=0&id=490445d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490445d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VChip,VCol,VDivider,VForm,VRadio,VRadioGroup,VRow,VTextField})
